import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-lg-row flex-column" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedCourse = _resolveComponent("SelectedCourse")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ilos_edit = _resolveComponent("ilos-edit")!
  const _component_SubjectFlexibleILOs = _resolveComponent("SubjectFlexibleILOs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    loading: _ctx.loading,
    class: "card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_SelectedCourse, {
          appId: _ctx.appId,
          routeName: _ctx.changeScopeRouteName,
          "onUpdate:course": _ctx.setCourse
        }, null, 8, ["appId", "routeName", "onUpdate:course"])
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Subject")) + " " + _toDisplayString(_ctx.subject.name ? _ctx.subject.name : "..."), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.loading && !_ctx.error)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                class: "px-5 mx-5",
                ref: "form",
                modelValue: _ctx.validForm,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.validForm) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          lg: "4",
                          md: "12",
                          sm: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              id: "subjectAddEdit-txt-name",
                              rules: _ctx.nameRules,
                              label: _ctx.$t('Title'),
                              modelValue: _ctx.editSubject.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editSubject.name) = $event)),
                              modelModifiers: { trim: true }
                            }, null, 8, ["rules", "label", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          lg: "4",
                          md: "12",
                          sm: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              id: "subjectAddEdit-txt-lecturesCount",
                              type: "number",
                              label: _ctx.$t('lectureCount'),
                              modelValue: _ctx.editSubject.lectureCount,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editSubject.lectureCount) = $event)),
                              rules: _ctx.lectureCountRules
                            }, null, 8, ["label", "modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          lg: "4",
                          md: "12",
                          sm: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              disabled: !_ctx.courseActive,
                              items: _ctx.activeStatus,
                              "item-title": "text",
                              "item-value": "value",
                              "menu-props": { location: 'bottom', offset: 10 },
                              label: _ctx.$t('Active'),
                              hint: !_ctx.courseActive ? _ctx.$t('courseEditDisabled') : '',
                              modelValue: _ctx.editSubject.active,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editSubject.active) = $event)),
                              "persistent-hint": ""
                            }, null, 8, ["disabled", "items", "label", "hint", "modelValue"])
                          ]),
                          _: 1
                        }),
                        (_ctx.resError)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              variant: "outlined",
                              color: "warning",
                              class: "text-center d-lg-block d-none mx-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$utils.servertranslate(_ctx.resError)), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { col: "1" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('ILOS')), 1),
                            (!_ctx.isFlexibleILOs)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _createVNode(_component_ilos_edit, {
                                    ilos: _ctx.courseILOS,
                                    selectedIlos: _ctx.editSubject.ilos as HeaderILos
                                  }, null, 8, ["ilos", "selectedIlos"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createVNode(_component_SubjectFlexibleILOs, {
                                    items: _ctx.flexibleILOs,
                                    onUpdateFlexibleIlos: _ctx.updateFlexibleILOs
                                  }, null, 8, ["items", "onUpdateFlexibleIlos"])
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_card_actions, { class: "pt-5 mt-5" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "flat",
                        class: "d-lg-block d-none mx-1",
                        onClick: _ctx.onSaveClick,
                        id: "btn-subject-edit-save"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("buttons.save")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        class: "d-lg-block d-none mx-1 blue-grey white--text",
                        id: "btn-subject-edit-back",
                        onClick: _ctx.onBackClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("buttons.back")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 2,
            variant: "outlined",
            color: "warning",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$utils.servertranslate(_ctx.error)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.resError)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 3,
            variant: "outlined",
            color: "warning",
            class: "d-lg-none mx-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$utils.servertranslate(_ctx.resError)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                class: "d-lg-none flex-md-grow-0 flex-grow-1 mx-1",
                onClick: _ctx.onSaveClick,
                id: "btn-subject-edit-save"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("buttons.save")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                class: "d-lg-none flex-md-grow-0 flex-grow-1 mx-1 blue-grey white--text",
                id: "btn-subject-edit-back",
                onClick: _ctx.onBackClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("buttons.back")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}